import {TextField} from "../../../styles/config";
import React from "react";
import {useIntl} from "react-intl";


const LanguageFields = ({initialValues, handleBlur, handleChange, values, errors, languages, isLoading, touched, moduleName}) => {

    const intl = useIntl();

    return (
        languages.map(language => {
            const value = values[language.id] !== undefined ? values[language.id] : initialValues[language.id].length !== undefined ? initialValues[language.id] : '';
            return (
                <TextField
                    key={language.id}
                    id={`${language.id}`}
                    className="bg-white"
                    margin="dense"
                    variant="outlined"
                    type="text" autoComplete="off"
                    disabled={isLoading}
                    label={`${language.name}`}
                    fullWidth={true}
                    placeholder={`${intl.formatMessage({id: 'TABLE.NAME'})}`}
                    name={`${language.id}`}
                    onBlur={handleBlur}
                    onChange={handleChange}
                    value={value || ''}
                    helpertext={errors[language.id] !== undefined ? errors[language.id] : ''}
                    error={Boolean(touched[language.id] && errors[language.id] !== undefined)}
                />
            )
        })

    );
}

export default LanguageFields;
